import * as React from "react";
import { Button, ButtonProps } from "./button";

interface IconButtonProps extends ButtonProps {
  isIcon?: boolean;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <Button isIconButton ref={ref} {...props}>
        {props.children}
      </Button>
    );
  }
);

IconButton.displayName = "IconButton";
